import { palette } from '@livable/saas-react-components';
import breakpointsFunc from '../breakpointsFunc';
const MuiTableContainer = {
  styleOverrides: {
    root: {
      boxShadow: palette.shadows.light,
      borderRadius: '2px'
    }
  },
  variants: [{
    props: {
      variant: 'plain'
    },
    style: {
      boxShadow: 'none',
      '& .MuiTableCell-root': {
        paddingTop: '10px',
        paddingBottom: '10px',
        '&:first-of-type': {
          paddingLeft: '10px'
        },
        '&:last-of-type': {
          paddingRight: '10px'
        }
      },
      '& .MuiTableBody-root .MuiTableRow-root': {
        '& .MuiTableCell-root': {
          border: 'none'
        },
        '&:nth-of-type(odd)': {
          backgroundColor: palette.shades[200]
        }
      }
    }
  }, {
    props: {
      variant: 'summary'
    },
    style: {
      boxShadow: 'none',
      padding: '0',
      '.MuiTableCell-root': {
        padding: '10px 0',
        borderBottom: 'none',
        '&:last-of-type': {
          paddingRight: '0'
        },
        '&:first-of-type': {
          paddingLeft: '0'
        }
      },
      '.MuiTableBody-root': {
        '& tr:first-of-type td': {
          paddingTop: '0'
        },
        '& tr:last-of-type td': {
          paddingBottom: '0'
        }
      },
      '.MuiTableRow-root': {
        '+ .MuiTableRow-root': {
          borderTop: "1px solid ".concat(palette.shades[300])
        },
        '& td:first-of-type': {
          color: palette.shades[700]
        }
      },
      [breakpointsFunc.breakpoints.down('sm')]: {
        '.MuiTableBody-root': {
          display: 'block'
        },
        '.MuiTableRow-root': {
          display: 'block'
        },
        '.MuiTableCell-root': {
          display: 'block',
          '&:first-of-type': {
            paddingBottom: '0'
          },
          '&:last-of-type': {
            paddingTop: '0'
          }
        },
        '.MuiTableCell-alignRight': {
          textAlign: 'left'
        }
      }
    }
  }, {
    props: {
      variant: 'grey'
    },
    style: {
      boxShadow: 'none',
      '& .MuiTableRow-root': {
        backgroundColor: palette.shades[200],
        borderRadius: '2px'
      }
    }
  }]
};
export default MuiTableContainer;